"use strict";

var _classCallCheck = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/inherits");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _HtmlElement = _interopRequireDefault(require("./HtmlElement"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ClientScript =
/*#__PURE__*/
function (_react$Component) {
  _inherits(ClientScript, _react$Component);

  function ClientScript(props) {
    var _this;

    _classCallCheck(this, ClientScript);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClientScript).call(this, props));

    _this.mount = function (element) {
      var _this$props = _this.props,
          src = _this$props.src,
          type = _this$props.type,
          onReady = _this$props.onReady,
          children = _this$props.children;
      src && (element.src = src);
      children && (element.innerHTML = children);
      element.type = type;
      element.onload = onReady;
      document.body.appendChild(element);
    };

    var _this$props2 = _this.props,
        isLoaded = _this$props2.isLoaded,
        _onReady = _this$props2.onReady;
    _this.isLoaded = false; // Skip the check for SSR

    if (typeof window !== 'undefined') {
      _this.isLoaded = isLoaded && !!isLoaded(window);

      if (_this.isLoaded && _onReady) {
        _onReady();
      }
    }

    return _this;
  }

  _createClass(ClientScript, [{
    key: "render",
    value: function render() {
      if (this.isLoaded) {
        return null;
      }

      return _react["default"].createElement(_HtmlElement["default"], {
        tag: "script",
        mount: this.mount
      });
    }
  }]);

  return ClientScript;
}(_react.Component);

exports["default"] = ClientScript;
ClientScript.propTypes = {
  type: _propTypes.string,
  src: _propTypes.string,
  children: _propTypes.string,
  onReady: _propTypes.func,
  isLoaded: _propTypes.func
};
ClientScript.defaultProps = {
  type: 'text/javascript'
};